export default {
    ITEM_REMOVE: 'shopping-cart-item-remove',
    ITEM_AMOUNT_CHANGE: 'shopping-cart-item-amount-change',
    ITEM_AMOUNT_INCREASE: 'shopping-cart-item-amount-increase',
    ITEM_AMOUNT_DECREASE: 'shopping-cart-item-amount-decrease',
    CART_CHANGED: 'shopping-cart-changed',
    CART_CHANGED_ERROR: 'shopping-cart-changed-error',
    DISCOUNT_ADD: 'shopping-cart-discount-add',
    DISCOUNT_REMOVE: 'shopping-cart-discount-remove',
};
